/**************************************************
 * Nombre:       Formulario_Producto_Nombre
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";

import {Google, Lock} from "@mui/icons-material";
import IngresoTexto from "../Modulo_formularios/Componentes/IngresoTexto";


const Formulario_Login = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                spacing={2}
                sx={{p: 1}}
            >


                <Grid container size={12} sx={{justifyContent: 'center'}}>
                    <IngresoTexto Icono={Google} nombre={'Ingresa correo gmail'} dato={'correo'}  {...props}
                                  requerido={'El Correo ese requerido'} type={'mail'}

                    />
                </Grid>

                <Grid container size={12} sx={{justifyContent: 'center'}}>
                    <IngresoTexto Icono={Lock} nombre={'Contreseña'} dato={'pass'}  {...props}
                                  type={'password'}

                    />
                </Grid>


            </Grid>
        </form>

    )

}
export default Formulario_Login